import { takeLatest, put } from 'redux-saga/effects';
import { createAxios } from '../utils/utils';
import { RANK_ZT_RANK_APPS_53, RANK_RANK_APPS, RANK_RANKS } from '../config';
import {
  OTHER_RANK_APPS_REQUEST,
  OTHER_RANK_APPS_SUCCESS,
  RANK_RANK_APPS_REQUEST,
  RANK_RANK_APPS_SUCCESS,
  RANK_RANKS_REQUEST,
  RANK_RANKS_SUCCESS,
} from '../constants/topn';

/**
 * 单个排行榜单
 */
function* fetchOtherRankApps({ code = 'soft', skip = '0', limit = '20' }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RANK_ZT_RANK_APPS_53, {
      params: { code, skip, limit },
    });
    if (res.data.status === 0) {
      yield put({
        type: OTHER_RANK_APPS_SUCCESS,
        payload: { ...res.data.data, code, skip, limit },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 单个排行榜单
 */
function* fetchRankApps({ code = 'soft', skip = '0', limit = '20' }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RANK_RANK_APPS, {
      params: { code, skip, limit },
    });
    if (res.data.status === 0) {
      yield put({
        type: RANK_RANK_APPS_SUCCESS,
        payload: { ...res.data.data, code, skip, limit },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 排行页展示的多个排行(包含应用)
 */
function* fetchAllRanksAndApps() {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RANK_RANKS);
    if (res.data.status === 0) {
      yield put({
        type: RANK_RANKS_SUCCESS,
        payload: res.data.data,
      });
    }
  } catch (error) {
    // throw error;
  }
}


export function* watchOtherRankApps() {
  yield takeLatest(OTHER_RANK_APPS_REQUEST, fetchOtherRankApps);
}
export function* watchRankApps() {
  yield takeLatest(RANK_RANK_APPS_REQUEST, fetchRankApps);
}
export function* watchAllRanksAndApps() {
  yield takeLatest(RANK_RANKS_REQUEST, fetchAllRanksAndApps);
}
